import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/boggle.json";
import fr from "@/locales/fr/puzzle-types/boggle.json";

export const BOGGLE_NS = "puzzle-types/boggle";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerBoggleTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", BOGGLE_NS))
    i18n.addResourceBundle("en", BOGGLE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", BOGGLE_NS))
    i18n.addResourceBundle("fr", BOGGLE_NS, fr, true, true);
}
